import React from 'react';
import { metrics } from '../data/profile';
import { PageHeader } from '../components/PageHeader';
export function Impact() {
  return <section className="bg-parchment py-16 lg:py-24" data-id="element-123" data-mp="150510o5k81pj">
      <div className="mx-auto max-w-dossier px-6 lg:px-10" data-id="element-124" data-mp="1023gdyshjuby">
        <PageHeader overline="Impact Metrics" title="The numbers a board will ask for first" description="Scope, stewardship, and measurable outcome — verified across HPE enterprise reporting." data-id="element-125" data-mp="100im8aa32dem" />

        <dl className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8" data-id="element-126" data-mp="1nsfnx8jtjp20">
          {metrics.map(metric => <div key={metric.label} className="flex flex-col bg-navy p-8 lg:p-9" data-id="element-127" data-mp="1jpj97sxegd3c">
              <dd className="font-display text-4xl leading-none text-white lg:text-[42px]" data-id="element-128" data-mp="1es0zw1fgzvut">
                {metric.value}
              </dd>
              <dt className="mt-5 font-sans text-base font-medium leading-snug text-white" data-id="element-129" data-mp="8d090a5ay3v3">
                {metric.label}
              </dt>
              <dd className="mt-auto pt-6 font-sans text-[13px] leading-relaxed text-navy-200/75" data-id="element-130" data-mp="2gecmukyub9fk">
                {metric.detail}
              </dd>
            </div>)}
        </dl>

        <p className="mt-10 max-w-2xl font-sans text-sm leading-relaxed text-navy-400" data-id="element-131" data-mp="27derss6dqc94">
          Figures reflect direct accountability rather than shared or matrixed ownership, and cover
          global pension assets, program budget, M&amp;A integration volume, and service
          modernization outcomes.
        </p>
      </div>
    </section>;
}